import { render, staticRenderFns } from "./ChatContextSiteHeader.vue?vue&type=template&id=241100a4&scoped=true"
import script from "./ChatContextSiteHeader.vue?vue&type=script&lang=js"
export * from "./ChatContextSiteHeader.vue?vue&type=script&lang=js"
import style0 from "./ChatContextSiteHeader.vue?vue&type=style&index=0&id=241100a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241100a4",
  null
  
)

export default component.exports